import React from 'react'
import { Grid, Cell, InputTypes, Button } from 'react-foundation'

import '../../styles/record.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faListAlt, faEye, faEdit} from '@fortawesome/free-solid-svg-icons'

import Modal from 'react-foundation-modal';
import Loader from 'react-loader-spinner'

import Axios from 'axios'
import config from '../../config/config'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const overlayStyle = {
    'backgroundColor': 'rgba(0,58,102,.45)'
    };

export default class MainTableUsersSystemComponent extends React.Component{

    constructor(){
        super()


        this.state = {
            idRecord:0,
            users:[],
            modalIsOpen: false,
            textToSearch:"",
            user:{},
            title:"",
            isEditing:false,
            name:"",
            email:"",
            phone:"",
            cellphone:"",
            password:"",
            nickName:"",
            id_user:0
        }


        this.drawRows = this.drawRows.bind(this)
        this.updateRecordSelected = this.updateRecordSelected.bind(this)
        this.selectRow = this.selectRow.bind(this)
        this.getUsers = this.getUsers.bind(this)
        this.getUser = this.getUser.bind(this)
        this.buttonUpdate = this.buttonUpdate.bind(this)
        this.handleSubmitUser = this.handleSubmitUser.bind(this)

    }

    showPopup = (status) => {
        this.setState({
            modalIsOpen: status
        });
    }

    updateRecordSelected(idRecord){
        this.setState({idRecord:idRecord}, this.showPopup(true))
    }

    selectRow(idRecord){
        this.props.onhandleSelectRecord(true, idRecord)
    }

    UNSAFE_componentWillMount(){
        this.getUsers()
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        this.getUsers(nextProps.textToSearch)
    }

    getUsers(textToSearch){
        var self = this

        Axios.get(`${config.getIPAddress()}api/v1/users?total_rows=${1000}&current_page=${1}&user_name=${textToSearch != undefined ? textToSearch : ""}`,{
            total_rows:1000,
            current_page:1
        }).then(response => {

            if(response.status == 200){
                self.setState({users: response.data.data})
            }
        
        }).catch(err =>{
            //console.log(err)
        })
    }

    getUser(idUser){


        const self = this

        self.setState({user:{}, id_user:0})

        Axios.get(`${config.getIPAddress()}api/v1/users/${idUser}`,{
            total_rows:1000,
            current_page:1
        }).then(response => {
            if(response.status == 200){
                self.setState({user: response.data.res[0], id_user:idUser})
            }
        }).catch(err =>{
            //console.log(err)
        })

    }

    handleSubmitUser(event){
        event.preventDefault()

        const self = this

        Axios.put(`${config.getIPAddress()}api/v1/users`,{
            id:self.state.id_user,
            name:self.state.name,
            email:self.state.email,
            phone:self.state.phone,
            cellphone:self.state.cellphone,
            password:self.state.password
    }).then(response => {
        if(response.status == 200){
            toast.success("Usuario actualizado correctamente.", {containerId: 'A'})
            self.props.onhandleuserRegistered()
            self.showPopup()
        }
        else if(response.status == 404){
            toast.error("Ocurrió un problema verifica los campos he intetalo de nuevo,", {containerId: 'A'})
        }

    }).catch(err => {
        //console.log(err)
        toast.error("Ocurrió un problema, si el problema persiste contacta al administrador,", {containerId: 'A'})
    })
    }

    //1 actualización
    //0 sin actualización
    //2 sin cambio

    drawRows(){


        if(this.state.users.length > 0){

            var rows = this.state.users.map( data => {
                var status = ""

                return(
                    <tr>
                        <td>
                            <span>{data.userName}</span>
                        </td>
                        <td>
                            <span>{data.userEmail}</span>
                        </td>
                        <td>
                            <span>{data.role == "lawyer" ? "Abogado" : data.role}</span>
                        </td>
                        <td>
                            <span>{data.isActive == 1 ? "Activo" : "Inactivo"}</span>
                        </td>
                        <td>
                            <a style={{marginLeft:"5px"}} href="#" onClick={() => { 
                                this.setState({isEditing:false, title:"Visualizar Usuario"})
                               this.getUser(data.idUser)
                               this.showPopup(true)
                            }}><FontAwesomeIcon icon={faEye} size="1x"/></a>
                            <a style={{marginLeft:"5px"}} href="#" onClick={() => { 
                                this.setState({isEditing:true, title:"Actualizar Usuario"})
                                this.getUser(data.idUser)
                               this.showPopup(true)
                            }}><FontAwesomeIcon icon={faEdit} size="1x"/></a>
                        </td>
                    </tr>
                )
            })

            return rows

        }else{
            return(
                <tr>
                    <td colSpan={6} style={{textAlign:"center"}}>
                        <b>No hay datos que mostrar.</b>
                        <Loader
                            type="Puff"
                            color="#003A66"
                            height={100}
                            width={100}
                            timeout={10000} //3 secs
                        />
                    </td>
                </tr>
            )
        }

    }

    buttonUpdate(){
        
        return this.state.isEditing ? <Button>Actualizar</Button> : false
    }

    render(){
        return(
            <Grid>
                <Cell small={12} medium={12} large={12}>
                    <table className="hover unstriped">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Correo Electrónico</th>
                                <th>Role</th>
                                <th>Estatus</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.drawRows()}
                        </tbody>
                    </table>

                    <Modal 
                        open={this.state.modalIsOpen}
                        closeModal={this.showPopup}
                        isModal={true}
                        size="small"
                        overlayStyle={overlayStyle} >

                        <form onSubmit={(self) => this.handleSubmitUser(self)} style={{textAlign:"left"}}>
                            <h3>{this.state.title}</h3>
                            <Grid>
                                <Cell className="cn-fr" small={6} medium={6} large={6}>
                                    <label>Email</label>
                                    <input type="text" 
                                    readOnly={!this.state.isEditing ? true : false}
                                    defaultValue={this.state.user.email}
                                    onChange={(input)=>{
                                        this.setState({email:input.target.value})
                                    }}
                                    />
                                </Cell>
                                <Cell className="cn-fr" small={6} medium={6} large={6}>
                                    <label>Nombre</label>
                                    <input type="text" 
                                    readOnly={!this.state.isEditing ? true : false}
                                    defaultValue={this.state.user.userName}
                                    onChange={(input)=>{
                                        this.setState({name:input.target.value})
                                    }}/>
                                </Cell>
                                <Cell className="cn-fr" small={6} medium={6} large={6}>
                                    <label>Usuario</label>
                                    <input type="text" 
                                    readOnly={!this.state.isEditing ? true : false}
                                    defaultValue={this.state.user.nickName}
                                    onChange={(input)=>{
                                        this.setState({nickName:input.target.value})
                                    }}/>
                                </Cell>
                                <Cell style={{display:this.state.isEditing ? "inline-block" : "none"}} className="cn-fr" small={6} medium={6} large={6}>
                                    <label>Contraseña</label>
                                    <input type="password" 
                                    readOnly={!this.state.isEditing ? true : false}
                                    onChange={(input)=>{
                                        this.setState({password:input.target.value})
                                    }}/>
                                </Cell>
                                <Cell style={{display:this.state.isEditing ? "none" : "inline-block"}} className="cn-fr" small={6} medium={6} large={6}>
                                    <label>Rol</label>
                                    <input type="text" 
                                    readOnly={!this.state.isEditing ? true : false} 
                                    defaultValue={"Abogado"}/>
                                </Cell>
                                <Cell className="cn-fr" small={6} medium={6} large={6}>
                                    <label>Teléfono de oficina + ext</label>
                                    <input type="text" 
                                    readOnly={!this.state.isEditing ? true : false} 
                                    defaultValue={this.state.user.phone}
                                    onChange={(input)=>{
                                        this.setState({phone:input.target.value})
                                    }}/>
                                </Cell>
                                <Cell className="cn-fr" small={6} medium={6} large={6}>
                                    <label>Teléfono celular</label>
                                    <input type="text" 
                                    readOnly={!this.state.isEditing ? true : false} 
                                    defaultValue={this.state.user.cellphone}
                                    onChange={(input)=>{
                                        this.setState({cellphone:input.target.value})
                                    }}/>
                                </Cell>
                             
                            </Grid>


                            <Cell className="text-right" small={12} medium={12} large={12} >
                                   {this.buttonUpdate()} 
                                </Cell>

                        </form>

                        


                    </Modal>  
                </Cell>
            </Grid>
        )
    }
}